import React from "react";
import {
  FaBullseye,
  FaCheckCircle,
  FaGraduationCap,
  FaQuestionCircle,
  FaShieldAlt,
} from "react-icons/fa";

export default function QuizHero({
  score = 0,
  current = 0,
  total = 0,
  finished = false,
  loading = false,
  availableTechniquesCount = 0,
  includeSelfDefense = false,
  grade = "Toutes les ceintures",
}) {
  const questionLabel = total
    ? finished
      ? `${total}/${total}`
      : `${Math.min(current + 1, total)}/${total}`
    : "0/0";

  const scoreLabel = loading ? "..." : score;
  const techniquesLabel = loading ? "..." : availableTechniquesCount;

  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-violet-500/30 blur-3xl" />

      <div className="relative">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          <FaQuestionCircle className="text-[0.7rem]" />
          Révision technique
        </p>

        <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Quizz Techniques
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Devine la technique à partir de l’image : 10 questions, 4
              propositions et une correction immédiate pour progresser au dojo.
            </p>

            <div className="mt-3 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaGraduationCap className="text-sky-200" />
                {grade}
              </span>

              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaShieldAlt className="text-violet-200" />
                {includeSelfDefense
                  ? "Self-Défense incluse"
                  : "Judo classique"}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:min-w-[360px]">
            <HeroStat
              icon={FaBullseye}
              label="Question"
              value={questionLabel}
            />

            <HeroStat
              icon={FaCheckCircle}
              label="Score"
              value={scoreLabel}
            />

            <HeroStat
              icon={includeSelfDefense ? FaShieldAlt : FaGraduationCap}
              label="Techniques"
              value={techniquesLabel}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>

      <p className="mt-1 text-[11px] font-medium text-slate-300">
        {label}
      </p>
    </div>
  );
}